import {
    SelectValue as AriaSelectValue,
    SelectValueProps as AriaSelectValueProps,
} from 'react-aria-components';

import { css } from '@allenai/varnish-panda-runtime/css';

import { cx } from '@/utils/cx';

import selectRecipe, { SelectRecipeProps } from '@/components/select/select.styles';
import focusRing from '@/components/shared/focusRing.styles';

type SelectValueProps = {
    label?: string;
    className?: string;
} & AriaSelectValueProps<HTMLDivElement> &
    SelectRecipeProps;

const SelectValue = ({ className, ...rest }: SelectValueProps) => {
    const [variantProps, localProps] = selectRecipe.splitVariantProps(rest);
    // `raw` receipe is required to be able to merge css objects (used in focus ring)
    const recipeClassNames = selectRecipe.raw(variantProps);
    return (
        <AriaSelectValue
            {...localProps}
            // we need to wrap the `raw` focusRing and `raw` recipeClassNames.thumb in `css()` to merge them
            // there is no garauntee which class will take precidence
            className={cx(css(recipeClassNames.selectValue, focusRing), className)}
        />
    );
};

export { SelectValue, SelectValue as default };
export type { SelectValueProps };
